import React, { Component } from "react";
import { NavLink, Link } from "react-router-dom";
import { withRouter } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { compile, pathToRegexp } from "path-to-regexp";

import { makeStyles } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import Container from "@material-ui/core/Container";
import MenuItem from "@material-ui/core/MenuItem";
import Menu from "@material-ui/core/Menu";

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: "#fbb800",
    padding: 10
  }
}));

const LANGUAGES = ["de", "en", "fr", "it", "nl", "pl", "sk", "se"];

export const generateLanguage = (locale, location) => {
  const ROUTE = "/:locale/:path*";
  const definePath = compile(ROUTE);
  const routeComponents = pathToRegexp(ROUTE).exec(location.pathname);

  let subPaths = null;
  // if (routeComponents && routeComponents[2]) {
  //   subPaths = routeComponents[2].split("/");
  // }

  return definePath({
    locale,
    path: subPaths
  });
};

const langagesOptions = LANGUAGES.map(language => ({
  translation: language,
  title: language
}));

function Navbar({ changeLanguage, locale, location, match }) {
  const { t } = useTranslation();
  const classes = useStyles();

  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleOpen = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuItemClick = (event, index, language) => {
    changeLanguage(language);
    setAnchorEl(null);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <Container
      fixed={false}
      disableGutters
      maxWidth={false}
      className={classes.root}
    >
      <Box display="flex" alignItems="center">
        <Box flexGrow={1}>
          <a
            href={`https://www.dako.eu/${locale}/`}
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src="logo.png"
              alt=""
              style={{
                width: "160px",
                height: "49px"
              }}
              width={160}
              height={49}
            />
          </a>
        </Box>
        <Box flexGrow={0} display="flex" alignItems="center">
          <Button
            aria-controls="simple-menu"
            aria-haspopup="true"
            onClick={handleOpen}
          >
            {locale}
          </Button>
          <Menu
            id="language-selector"
            anchorEl={anchorEl}
            keepMounted
            open={Boolean(anchorEl)}
            onClose={handleClose}
          >
            {LANGUAGES.map((language, index) => (
              <Link to={generateLanguage(language, location)}>
                <MenuItem
                  onClick={event => handleMenuItemClick(event, index, language)}
                >
                  {language}
                </MenuItem>
              </Link>
            ))}
          </Menu>
        </Box>
      </Box>
    </Container>
  );
}

export default withRouter(Navbar);
